import { render, staticRenderFns } from "./selectConfigVars.vue?vue&type=template&id=038a28ca&scoped=true"
import script from "./selectConfigVars.vue?vue&type=script&lang=js"
export * from "./selectConfigVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a28ca",
  null
  
)

export default component.exports